import { isPrincipalAgentInfoEnabled } from 'src/utils/capabilities';
import { hasQuestion, isVerifiedExternally } from 'src/utils/compliance';

const customStepsCatalog = {};

const steps = {
  '/onboarding': {
    menu: 'Agency Information',
    next: agency => {
      if (isVerifiedExternally(agency.compliance_status)) {
        if (hasQuestion('florida_license')) {
          return '/onboarding/florida-license';
        }
        return `/onboarding/my-profile`;
      }
      return '/onboarding/address';
    },
    current: '/onboarding',
    progressLabel: 'Agency Information',
    progressEdit: '/onboarding',
    firstProgress: true,
  },
  '/onboarding/address': {
    menu: 'Agency Information',
    next: () =>
      hasQuestion('florida_license')
        ? '/onboarding/florida-license'
        : '/onboarding/my-profile',
    back: '/onboarding',
    current: '/onboarding/address',
    progressLabel: 'Agency Information',
  },
  '/onboarding/florida-license': {
    menu: 'Agency Information',
    next: '/onboarding/my-profile',
    back: agency =>
      isVerifiedExternally(agency.compliance_status)
        ? '/onboarding'
        : '/onboarding/address',
    current: '/onboarding/florida-license',
    progressLabel: 'Agency Information',
  },
  '/onboarding/my-profile': {
    menu: isPrincipalAgentInfoEnabled
      ? 'Personal Information'
      : 'Agency Information',
    next: () => {
      if (hasQuestion('distribution_agreement')) {
        return '/onboarding/distribution-agreement';
      }
      return '/onboarding/agents';
    },
    back: agency => {
      if (hasQuestion('florida_license')) {
        return '/onboarding/florida-license';
      }
      if (isVerifiedExternally(agency.compliance_status)) {
        return '/onboarding';
      }
      return '/onboarding/address';
    },
    current: '/onboarding/my-profile',
  },
  '/onboarding/distribution-agreement': {
    next: '',
    menu: 'Sign',
    back: '/onboarding/my-profile',
    current: '/onboarding/distribution-agreement',
    progressLabel: 'Sign',
  },
  '/onboarding/agents': {
    next: '/',
    menu: 'Add Agents',
    back: '/onboarding/my-profile',
    current: '/onboarding/agents',
    progressLabel: 'Add Agents',
  },
  '/onboarding/complete': {
    next: '',
    menu: 'Add Agents',
    back: '/onboarding/agents',
    current: '/onboarding/complete',
    progressLabel: 'Add Agents',
  },
  '/onboarding/agents/:agentId/edit': {
    next: '/onboarding/agents',
    menu: 'Add Agents',
    back: '/onboarding/agents',
  },
  '/onboarding/agents/new': {
    next: '/onboarding/agents',
    menu: 'Add Agents',
    back: '/onboarding/agents',
    current: '/onboarding/agents/new',
    progressLabel: 'Add Agents',
    firstProgress: true,
    progressEdit: '/onboarding/agents',
  },
};

export default { steps, customStepsCatalog };
